<script setup lang="ts">
import { computed } from 'vue'

import { classMerge, Button, TableOfContentWrapper, TableOfContentBody, type TableOfContentItemType } from '@toni/brand-ui'

const props = defineProps<{
  items: TableOfContentItemType[],
  twClass?: string,
}>()

const isHorizontal = computed(() => props.items.length <= 5)

const scrollToAnchor = (href: string) => {
  const headerHeightWithOffset = 90
  const element = document.querySelector(href)
  if (element) {
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.scrollY - headerHeightWithOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }
}
</script>

<template>
  <TableOfContentWrapper :class="classMerge('', twClass)">
    <slot name="header" />
    <TableOfContentBody class="flex flex-col md:flex-row md:[&:has(>:nth-child(6))]:flex-col gap-4 md:gap-5">
      <Button v-for="(item, index) in items"
              :key="item.href"
              variant="link"
              :class="['max-w-full text-button-xs md:text-button-md gap-1 md:gap-1.5',
                       isHorizontal && index !== items.length - 1
                         ? 'md:relative md:mr-3 md:after:absolute md:after:block md:after:bg-neutral-200 md:after:-right-4.5 md:after:top-[40%] md:after:w-1.5 md:after:h-1.5 md:after:rounded-full'
                         : ''
              ]"
              @click="scrollToAnchor(item.href ?? '')">
        <span class="truncate overflow-hidden whitespace-nowrap">
          {{ item.text }}
        </span>
        <slot name="icon" />
      </Button>
    </TableOfContentBody>
  </TableOfContentWrapper>
</template>
